import { thousandsRegex } from "core/constants/regex";

export const roundTo = (num: any, x: any) => {
  // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  return +(Math.round(num + "e+" + x) + "e-" + x);
};

export const formatBytes = (bytes: any, decimals: any) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const numberSequenceAlias = {
  1: "Pertama",
  2: "Kedua",
  3: "Ketiga",
  4: "Keempat",
  5: "Kelima",
  6: "Keenam",
  7: "Ketujuh",
  9: "Kesembilan",
  10: "Kesepuluh",
  11: "Kesebelas",
  12: "Keduabelas",
};

export const toThousand = (number: any, separators = ",") => {
  return number?.toString().replace(thousandsRegex, separators);
};

export const localeNumber = (number: any, locale = "id-ID") => {
  return number?.toLocaleString(locale);
};

export const abbreviateNumber = (num: any) => {
  if (!num) return 0;
  if (num >= 1000000000) return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
  if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  return num.toString();
};

export const toOrdinalNumber = (number: number) => {
  let suffix;
  if (10 <= number % 100 && number % 100 <= 20) {
    suffix = "th";
  } else {
    const suffixes = { 1: "st", 2: "nd", 3: "rd" } as { [key: number]: string };
    const lastDigit = number % 10;
    suffix = suffixes[lastDigit] || "th";
  }

  return `${number}${suffix}`;
};
